import * as React from "react";
import { Tooltip } from "../tooltip/tooltip.mjs";
import { TooltipToggle } from "../tooltip-toggle/tooltip-toggle.mjs";
const ChannelTooltip = (props) => {
  const { channel } = props;
  if (channel.description) {
    return /* @__PURE__ */ React.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React.createElement(TooltipToggle, { id: "channel-".concat(channel.id, "-tooltip") }, channel.title) }, /* @__PURE__ */ React.createElement("div", null, channel.description));
  }
  return /* @__PURE__ */ React.createElement("p", null, channel.title);
};
export {
  ChannelTooltip
};
